import React from 'react'

// Packages
import { Helmet } from 'react-helmet'

// Components
import AdminLoader from '../../components/Admin/AdminLoader';
import AdminNav from '../../components/Admin/AdminNav'
import Header from '../../components/Global/Header'
import Footer from '../../components/Global/Footer'
import RequireAdmin from '../../components/Admin/RequireAdmin'

// Helpers
import { toTitleCase } from '../../utils/helpers'

// Helper functions
function currentSection(path) {
  return path.substring(path.lastIndexOf('/') + 1)
}

const AdminPortal = ({ appName, children, isLoading, path }) => (
  <div className="user-portal locker-portal">
    <RequireAdmin />
    <Helmet>
      <title>{appName} | Admin | {toTitleCase(currentSection(path))}</title>
    </Helmet>
    <Header path={path} />
    <div className="locker-portal-inner">
      <div className="locker-portal-inner-content">
        <AdminNav currentSection={currentSection(path)} />
        {
          isLoading ? <AdminLoader /> : children
        }
      </div>
    </div>
    <Footer appName={ appName } />
  </div>
)


export default AdminPortal;



// WEBPACK FOOTER //
// ./src/screens/Admin/AdminPortal.js